import {Component, OnInit} from '@angular/core';
import {UtilitiesService} from '../../helpers/utilities.service';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss']
})
export class FAQ implements OnInit {

    constructor(public utils: UtilitiesService) {
    }

    ngOnInit(){
        const accordion = document.getElementsByClassName('container');

        for (var i=0; i<accordion.length; i++) {
        accordion[i].addEventListener('click', function () {
            this.classList.toggle('active')
        })
    }
    }

}